<div class="min-h-screen">
  <tui-loader
    [overlay]="true"
    [inheritColor]="true"
    [showLoader]="
      (phase$ | async) === 'parsing' || (phase$ | async) === 'saving'
    "
  >
    @if ((phase$ | async) === 'parsing') {
      <div
        class="flex flex-col items-center justify-center py-16 px-8 text-center"
      >
        <p class="text-lg text-gray-700">{{ parsingMessage }}</p>
      </div>
    } @else if ((phase$ | async) === 'upload') {
      <div class="p-4">
        <h2 class="font-semibold text-lg mb-4">Загрузка PDF-инвойса</h2>
        <div class="mb-6">
          <app-file-input
            [formControl]="fileControl"
            accept=".pdf,application/pdf"
          ></app-file-input>
        </div>
      </div>

      <div class="flex bottom-0 w-full fixed p-2 justify-end gap-x-2 bg-white">
        <button (click)="closeDialog()" appearance="outline" size="m" tuiButton>
          Отмена
        </button>
        <button
          (click)="upload$.next()"
          [disabled]="!fileControl.value"
          size="m"
          tuiButton
        >
          Загрузить
        </button>
      </div>
    } @else {
      <div class="flex fixed top-0 gap-x-2 w-full p-2 app-document-header z-10">
        <app-autocomplete
          (valueChanged)="fillSeller$.next($event)"
          label="Питомник (продавец)"
          [labelOutside]="false"
          class="w-4/12"
          [formControl]="invoiceForm.controls.seller"
          [items]="farms$ | async"
          [itemValue]="'name'"
          [itemText]="'name'"
          [displayValue]="'name'"
          [itemSearch]="'search'"
          [strict]="false"
        >
        </app-autocomplete>
        <app-autocomplete
          (valueChanged)="fillBuyer$.next($event)"
          label="Покупатель"
          [labelOutside]="false"
          class="w-4/12"
          [formControl]="invoiceForm.controls.buyer"
          [items]="intermediaries$ | async"
          [itemValue]="'name'"
          [itemText]="'name'"
          [displayValue]="'name'"
          [itemSearch]="'search'"
          [strict]="false"
        >
        </app-autocomplete>
        <tui-input
          class="w-2/12"
          tuiTextfieldSize="m"
          [formControl]="invoiceForm.controls.number"
        >
          Номер
        </tui-input>
        <div class="w-2/12 shrink-0">
          <app-input-date
            label="Дата"
            [formControl]="invoiceForm.controls.date"
          ></app-input-date>
        </div>
      </div>
      <div class="px-4">
        <div class="my-20">
          <div class="flex gap-x-2 mb-4">
            <tui-input-number
              class="w-[150px] shrink-0"
              decimal="always"
              [precision]="2"
              tuiTextfieldSize="m"
              [formControl]="invoiceForm.controls.cost"
            >
              Стоимость
            </tui-input-number>
            <app-autocomplete
              class="w-[150px] shrink-0"
              label="Валюта"
              [labelOutside]="false"
              [itemValue]="'letterCode'"
              [itemText]="'name'"
              [items]="CURRENCIES"
              [formControl]="invoiceForm.controls.currencyLetter"
            ></app-autocomplete>
          </div>

          <h3 class="font-semibold mb-2">Позиции</h3>
          <div class="mb-4 bg-neutral-100 rounded-lg p-2">
            @for (
              item of items.controls;
              track index;
              let index = $index;
              let last = $last
            ) {
              <div class="flex flex-nowrap gap-2 items-center mb-2">
                <tui-input
                  class="w-[250px] shrink-0"
                  tuiTextfieldSize="m"
                  [formControl]="item.controls.name"
                >
                  Наименование
                </tui-input>
                <tui-input
                  class="w-[250px] shrink-0"
                  tuiTextfieldSize="m"
                  [formControl]="item.controls.ruName"
                >
                  Наименование РУ
                </tui-input>
                <tui-input-number
                  class="w-[100px] shrink-0"
                  decimal="always"
                  tuiTextfieldSize="m"
                  [formControl]="item.controls.quantity"
                >
                  Кол-во
                </tui-input-number>
                <tui-input-number
                  class="w-[100px] shrink-0"
                  decimal="always"
                  [precision]="2"
                  tuiTextfieldSize="m"
                  [formControl]="item.controls.price"
                >
                  Цена
                </tui-input-number>
                <tui-input-number
                  class="w-[100px] shrink-0"
                  decimal="always"
                  [precision]="2"
                  tuiTextfieldSize="m"
                  [formControl]="item.controls.cost"
                >
                  Стоимость
                </tui-input-number>
                <tui-input
                  class="w-[100px] shrink-0"
                  tuiTextfieldSize="m"
                  [formControl]="item.controls.size"
                >
                  Размер
                </tui-input>
                <tui-input
                  class="w-[100px] shrink-0"
                  tuiTextfieldSize="m"
                  [formControl]="item.controls.height"
                >
                  Высота
                </tui-input>
                <div
                  class="w-[120px] shrink-0"
                  tuiDropdownContext
                  #packageTypeDropdown="tuiDropdown"
                  [tuiDropdown]="packageTypeMenu"
                >
                  <tui-input
                    tuiTextfieldSize="m"
                    [formControl]="item.controls.packageType"
                  >
                    Тип упаковки
                  </tui-input>
                  <ng-template #packageTypeMenu>
                    <tui-data-list role="menu" tuiDataListDropdownManager>
                      <button
                        tuiOption
                        (click)="
                          openPackageTypeDialog$.next(
                            item.controls.packageType.value
                          );
                          packageTypeDropdown.toggle(false)
                        "
                      >
                        Добавить упаковку
                      </button>
                    </tui-data-list>
                  </ng-template>
                </div>

                <tui-input-number
                  class="w-[110px] shrink-0"
                  decimal="always"
                  [precision]="3"
                  tuiTextfieldSize="m"
                  [formControl]="item.controls.netWeight"
                >
                  Вес нетто
                </tui-input-number>
                <div class="flex gap-1 shrink-0">
                  <tui-hosted-dropdown #weightDropdown [content]="weightMenu">
                    <button
                      appearance="icon"
                      tuiIconButton
                      size="s"
                      icon="tuiIconMenu"
                      (click)="weightDropdown.close()"
                    ></button>
                  </tui-hosted-dropdown>

                  <ng-template #weightMenu>
                    <tui-data-list role="menu">
                      <button
                        tuiOption
                        (click)="
                          recalcItemWeight(item, true); weightDropdown.close()
                        "
                      >
                        Пересчитать вес
                      </button>
                      <button
                        tuiOption
                        (click)="recalcAllItemWeights(); weightDropdown.close()"
                      >
                        Пересчитать вес для всех
                      </button>
                    </tui-data-list>
                  </ng-template>
                  <button
                    appearance="accent"
                    size="s"
                    (click)="removeItem(index)"
                    tuiIconButton
                    icon="tuiIconTrash"
                  ></button>
                  @if (last) {
                    <button
                      size="s"
                      (click)="addItem()"
                      tuiIconButton
                      icon="tuiIconPlus"
                    ></button>
                  }
                </div>
              </div>
            } @empty {
              <button size="s" tuiButton icon="tuiIconPlus" (click)="addItem()">
                Добавить позицию
              </button>
            }
          </div>
        </div>
      </div>

      <div
        class="flex gap-x-2 fixed justify-between bottom-0 w-full app-document-header p-2"
      >
        <div class="w-[140px]">
          <tui-input-number
            class="contrast-disabled-field"
            tuiTextfieldSize="m"
            [formControl]="computed.controls.netWeight"
            >Вес нетто</tui-input-number
          >
        </div>
        <div class="flex gap-x-2">
          @if (context.data.openFile) {
            <button
              (click)="context.data.openFile()"
              appearance="secondary-destructive"
              tuiIconButton
              icon="tuiIconFileText"
              size="m"
            ></button>
          }
          <button
            (click)="closeDialog()"
            [disabled]="(phase$ | async) === 'saving'"
            appearance="outline"
            size="m"
            tuiButton
          >
            Отмена
          </button>

          <button
            (click)="save$.next()"
            [disabled]="!invoiceForm.valid || (phase$ | async) === 'saving'"
            size="m"
            tuiButton
          >
            {{ confirmText$ | async }}
          </button>
        </div>
      </div>
    }
  </tui-loader>
</div>
